const ContactUs = () => (
  <div className="bg-white p-6 rounded-lg shadow-md">
    <h2 className="text-xl font-bold mb-4">Contact Us</h2>
    <p>Email: sales@zollowup.com</p>
    <p>Phone: +91 9218028500</p>
  </div>
);

export default ContactUs;
